export enum GameCategoryTab {
    Featured,
    Baccarat,
    OtherGames,
    MultiBet,
}
